import http, { createApi } from '@core/fetch'
import { API_SETMEAL_LIST } from '@constant'

export default {
  // 直播列表
  list: createApi('/p/wedding/index.php/admin/APILiveChannel/liveManegeList'),
  // 商家购买价格信息
  buyInfo: createApi('/p/wedding/index.php/Admin/APILiveCountry/buy_info'),
  // 查看提报单信息
  reportFormData: body =>
    http.get('/p/wedding/index.php/admin/APILiveChannel/liveChannelDetail', {
      body
    }),
  // 新增直播
  addLiveChannel: body =>
    http.post('/p/wedding/index.php/admin/APILiveChannel/addLiveChannel', {
      body,
      ignore: [null, undefined]
    }),
  // 编辑直播
  editLiveChannel: body =>
    http.post('/p/wedding/index.php/admin/APILiveChannel/editLiveChannel', {
      body,
      ignore: [null, undefined]
    }),
  getPackageList: params =>
    http(API_SETMEAL_LIST, {
      body: params
    }), // 套餐列表
  // 获取不可用时间
  getUselessTime: createApi(
    '/p/wedding/index.php/admin/APILiveChannelReport/special_date'
  ),

  // 获取商学院列表
  getBetterCase: createApi(
    '/p/wedding/index.php/admin/APIBusinessCollege/LiveList'
  ),

  // 商学院优秀案例不再提示
  neverMindCase: body =>
    http.post('/p/wedding/index.php/admin/APIMerchant/LiveRecommend', { body }),

  // 直播消费记录
  consumeList: body =>
    http.get('/p/wedding/index.php/admin/APILiveBalance/consumeList', { body }),

  // 直播消费记录
  rechargeList: body =>
    http.get('/p/wedding/index.php/admin/APILiveBalance/rechargeList', {
      body
    }),

  // 直播余额充值
  rechargePay: body =>
    http.post('/p/wedding/index.php/admin/APILiveBuyInfo/pay', { body }),

  // 直播购买信息
  liveBuyInfo: body =>
    http.get('/p/wedding/index.php/admin/APILiveBuyInfo/buy_info', { body }),
  //直播推广信息
  livePopInfo: body =>
    http.get('/p/wedding/index.php/admin/APILiveBalance/LivePopInfo', { body }),

  //设置推广时长
  livePopTime: body =>
    http.post('/p/wedding/index.php/admin/APILiveBalance/LivePopTime', {
      body
    }),
  // 商学院文章
  liveChannelBusinessCollege: () =>
    http('/p/wedding/index.php/admin/APIBusinessCollege/LiveList'),

  //删除直播
  deleteLive: body =>
    http.post('/p/wedding/index.php/admin/APILiveChannel/delLive', { body }),
  //推广时间变化获取价格变化
  saveStartTimeDifference: body =>
    http('/p/wedding/index.php/admin/APILiveChannel/saveStartTimeDifference', {
      body
    }),

  // 判断是否进入直播管理页
  checkBuy: body =>
    http.get('/p/wedding/index.php/admin/APILiveChannel/checkBuy', { body })
}
